<template src="./FileUpload.html"></template>

<script>
import { formatDate } from '../../../utils/computeds'
import {
  uploadFile,
  createFiles,
  createCompanyFiles,
  getFilesByProcess,
  getFilesByCompany,
  deleteFile,
  deleteFileFirebase
} from '../../../services'
import { OnlyRisk } from '../../../utils/roles'
import { companyStorageFolder } from '../../../utils/storage'
import { mapGetters } from 'vuex'

export default {
  name: 'FileUpload',
  data: () => ({
    selectedFiles: [],
    percentage: 0,
    search: '',
    loading: false,
    files: []
  }),
  props: {
    entityType: {
      type: String,
      default: 'process',
      validator: value => ['process', 'company'].includes(value)
    },
    entityId: [String, Number],
    // Used to name the Firebase Storage folder for company files
    entityName: String
  },
  created () {
    this.listFile()
  },
  methods: {
    reset () {
      this.listFile()
      this.selectedFiles = []
    },
    storageFolder () {
      if (this.entityType === 'company') {
        return companyStorageFolder(this.entityName || this.entityId)
      }
      return 'Processes'
    },
    async listFile () {
      this.loading = true
      try {
        this.files = this.entityType === 'company'
          ? await getFilesByCompany(this.entityId)
          : await getFilesByProcess(this.entityId)
      } catch (err) {
        console.log('Error on list files:', err)
      } finally {
        this.loading = false
      }
    },
    async filesUpload () {
      try {
        const folder = this.storageFolder()
        const uploadedFiles = await Promise.all(
          this.selectedFiles.map(async (file, index) => ({
            name: file.name,
            url: await uploadFile(folder, `${new Date().getTime()}-${index}-${file.name}`, file)
          }))
        )

        if (this.entityType === 'company') {
          await createCompanyFiles(uploadedFiles, this.entityId)
        } else {
          await createFiles(uploadedFiles, this.entityId)
        }
        this.$swal({
          text: uploadedFiles.length > 1
            ? 'Se subieron los archivos con exito.'
            : 'Se subio el archivo con exito.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
        this.reset()
      } catch (error) {
        console.error('Error on upload file', error)
        this.$swal({
          text: 'Ocurrio un error, intenta mas tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
    creatorName (file) {
      return file.user ? `${file.user.name} ${file.user.lastName}` : ''
    },
    async deleteFile (file) {
      this.$swal({
        text: '¿Esta seguro de eliminar el archivo?',
        icon: 'warning',
        buttons: ['NO', 'SI'],
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
          try {
            await Promise.all([
              deleteFileFirebase(file.url),
              deleteFile(file.id)
            ])
            this.$swal({
              text: 'El archivo se elimino con exito',
              buttons: false,
              icon: 'success',
              timer: 3000
            })
            this.reset()
          } catch (err) {
            console.error('Error delete file', err)
          }
        }
      })
    }
  },
  computed: {
    formatDate,
    OnlyRisk,
    headers () {
      const headers = [
        { text: 'Archivo', value: 'name' },
        {
          text: 'Cargado por',
          value: 'user',
          sort: (a, b) => this.creatorName({ user: a }).localeCompare(this.creatorName({ user: b }))
        },
        { text: 'Fecha de carga', value: 'createdAt' }
      ]
      if (this.OnlyRisk(this.user.rol)) {
        headers.push({ text: '', value: 'actions', sortable: false, align: 'end' })
      }
      return headers
    },
    filteredFiles () {
      const search = this.search.trim().toLowerCase()
      if (!search) return this.files
      return this.files.filter(file =>
        file.name.toLowerCase().includes(search) ||
        this.creatorName(file).toLowerCase().includes(search)
      )
    },
    ...mapGetters({
      user: 'getUser'
    })
  }
}
</script>
